<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Are you sure?</modal-header>
        </div>
        Are you sure you want to delete this tag: "{{name}}" ?
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="No, go back" confirmText="Yes, delete"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {tagMixin} from '@/mixins/tagMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {modalMixin} from '@/mixins/modalMixin'

export default {
  name: 'modal_tag_confirm',
  mixins: [tagMixin, notificationMixin, modalMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String,
    name: String
  },
  data: () => ({}),
  mounted () {},
  computed: {},
  methods: {
    confirm () {
      this.close()
      this.startLoading()
      this.deleteTag(this.confirmId).then((response) => {
        this.getAllTagsCreative(this.$route.params.id).then(() => {
          if (this.tags.length === 0) {
            this.finishLoading()
            this.$router.push({path: `/creatives/${this.$route.params.id}/bulk`, redirect: `/creatives/${this.$route.params.id}/bulk`})
          }
          this.finishLoading()
          this.addNotification('success', response.reason)
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/tags/modal-tag-confirm.vue